import createIcon from '../../createIcon';

/**
 * @component @name VolumeOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMkMxNi41IDEwLjIzIDE1LjQ4IDguNzEgMTQgNy45N1YxMC4xOEwxNi40NSAxMi42M0MxNi40OCAxMi40MyAxNi41IDEyLjIyIDE2LjUgMTJaTTE5IDEyQzE5IDEyLjk0IDE4LjggMTMuODIgMTguNDYgMTQuNjRMMTkuOTcgMTYuMTVDMjAuNjMgMTQuOTEgMjEgMTMuNSAyMSAxMkMyMSA3LjcyIDE4LjAxIDQuMTQgMTQgMy4yM1Y1LjI5QzE2Ljg5IDYuMTUgMTkgOC44MyAxOSAxMlpNNC4yNyAzTDMgNC4yN0w3LjczIDlIM1YxNUg3TDEyIDIwVjEzLjI3TDE2LjI1IDE3LjUyQzE1LjU4IDE4LjA0IDE0LjgzIDE4LjQ1IDE0IDE4LjdWMjAuNzZDMTUuMzggMjAuNDUgMTYuNjMgMTkuODEgMTcuNjkgMTguOTVMMTkuNzMgMjFMMjEgMTkuNzNMNC4yNyAzWk0xMiA0TDkuOTEgNi4wOUwxMiA4LjE4VjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VolumeOff = createIcon('VolumeOff', [
  [
    'path',
    {
      d: 'M16.5 12C16.5 10.23 15.48 8.71 14 7.97V10.18L16.45 12.63C16.48 12.43 16.5 12.22 16.5 12ZM19 12C19 12.94 18.8 13.82 18.46 14.64L19.97 16.15C20.63 14.91 21 13.5 21 12C21 7.72 18.01 4.14 14 3.23V5.29C16.89 6.15 19 8.83 19 12ZM4.27 3L3 4.27L7.73 9H3V15H7L12 20V13.27L16.25 17.52C15.58 18.04 14.83 18.45 14 18.7V20.76C15.38 20.45 16.63 19.81 17.69 18.95L19.73 21L21 19.73L4.27 3ZM12 4L9.91 6.09L12 8.18V4Z',
      key: '1pe500',
    },
  ],
]);

export default VolumeOff;
